jQuery(function ($) {

    let openNoteTrigger = $('.be-single-event-sidebar-info__referents li .open-note')
	
    // Open modal
    openNoteTrigger.on('click', function () {
        $(this).siblings('.be-single-event-sidebar-info__referents__note').addClass('active')
    })

    // Close modal
    let closeNoteTrigger = $('.be-single-event-sidebar-info__referents__note .close')

    closeNoteTrigger.on('click', function () {
        $('.be-single-event-sidebar-info__referents__note').removeClass('active')
    })

    //close modal on esc key
    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            $('.be-single-event-sidebar-info__referents__note').removeClass('active')
        }
    })

})